var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "focus:outline-none",
      class: _vm.linkStyle,
      on: { click: _vm.copyLink },
    },
    [_vm._v(" (" + _vm._s(_vm.buttonText) + ") ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }